/**
 * captioned-svg.js
 */

import React from 'react';
import { Typography } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(4)} ${theme.spacing(2)}`
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 250,
      textAlign: 'center',
      color: theme.palette.sys.onSurfaceVariant,
    },
    '& svg': {
      maxHeight: 110,
      width: 'auto',
      opacity: 0.4,
      margin: `${theme.spacing(3)} 0 ${theme.spacing(3)} 0`
    },
  }
}));


export default function CaptionedSvg(props) {
  const { image, text } = props;
  const classes = useStyles();

  return (
    <>
      <div className={`${classes.root} captioned-svg`}>
        <div>
          {image}
          <Typography variant='subtext-small'>{text}</Typography>
        </div>
      </div>
    </>
  )
}